/**
 * Item types for ungraded item types.
 */
const UngradedItemTypes = {
  UngradedPeer: 'peer',
  UngradedProgramming: 'ungradedProgramming',
};

export default UngradedItemTypes;

export const { UngradedPeer, UngradedProgramming } = UngradedItemTypes;
